// frontend/src/pages/Profile.tsx

import { useAuthStore } from '../store/authStore';
import { useProfileStats } from '../hooks/useProfileStats';
import { ProfileHeaderCard } from '../components/profile/ProfileHeaderCard';
import { ProfileStatsCard } from '../components/profile/ProfileStatsCard';
import { RecentBadgesCard } from '../components/profile/RecentBadgesCard';
import { AIUsageTimeline } from '../components/profile/AIUsageTimeline';
import '../styles/profile.css';

export function ProfilePage() {
  const profile = useAuthStore((s) => s.profile);
  const { stats, aiHistory, recentBadges, isLoading, error } = useProfileStats();

  if (!profile) return <div className="courses-loading">Yükleniyor...</div>;

  return (
    <div className="profile-page">
      <header className="profile-header">
        <h1>Profilim 👤</h1>
        <p>Öğrenme istatistiklerin ve başarıların</p>
      </header>

      {error && <div className="quiz-error-banner">{error}</div>}

      <div className="grid grid-2">
        <ProfileHeaderCard profile={profile} />

        <div>
          {isLoading || !stats ? (
            <div className="courses-loading">Yükleniyor...</div>
          ) : (
            <>
              <ProfileStatsCard stats={stats} />
              <RecentBadgesCard badges={recentBadges} />
            </>
          )}
        </div>
      </div>

      {!isLoading && <AIUsageTimeline entries={aiHistory} />}
    </div>
  );
}
